import React from "react";
import { Row, Col } from "antd";
import "./index.css";
import { MdModeEditOutline } from "react-icons/md";
const BusinessDescription = ({ companyDetails, businessDetailChange }) => {
  return (
    <Row>
      <Col span={24}>
        <Row>
          <Col xs={20} sm={20} md={23} lg={23} xl={23}>
            <h5 className="text-left">
              {companyDetails?.rmx_company_asset?.store_name}
            </h5>
          </Col>
          <Col xs={4} sm={4} md={1} lg={1} xl={1} align="right">
            <MdModeEditOutline
              className="pointer-cursor"
              size="25"
              onClick={() => businessDetailChange(companyDetails)}
            />
          </Col>
        </Row>
        <Row justify="start">
          <Col style={{ textAlign: "justify" }}>
            <span className="text-left ">
              {companyDetails?.rmx_company_asset?.description}
            </span>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};
export default BusinessDescription;
